import { render } from "./ErrorBox.vue?vue&type=template&id=4162e74c&scoped=true&ts=true"
import script from "./ErrorBox.vue?vue&type=script&lang=ts"
export * from "./ErrorBox.vue?vue&type=script&lang=ts"

import "./ErrorBox.vue?vue&type=style&index=0&id=4162e74c&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4162e74c"]])

export default __exports__